import { defineStore } from 'pinia';
import customFetch from "~/composables/custom-fetch";
import type {IServerConfig} from "~/shared/interfaces/config";

export const useConfigStore = defineStore('config', {
  state: () => ({
    config: null as IServerConfig | null,
  }),
  actions: {
    setConfig(config: IServerConfig) {
      this.config = config;
    },
  },
});
